import React from 'react'

export default function Placeholder(props) {
  return (
    <svg viewBox="0 0 610 610" {...props}>
      <path
        fill="var(--bg, #fff)"
        d="M304.9 0h.1c168.5 0 305 136.5 305 304.9v.2C610 473.5 473.5 610 305.1 610h-.1C136.5 610.1 0 473.6 0 305.2v-.2C0 136.5 136.5 0 304.9 0z"
      />
      <path
        fill="currentColor"
        d="M434.9 415.9c-19 0-34.5-15.7-34.5-35.1V162c0-19.3 15.5-35.1 34.5-35.1s34.5 15.7 34.5 35.1v218.8c0 19.3-15.5 35.1-34.5 35.1zm-129-26.7c-19 0-34.5-15.7-34.5-35.1V235.9c0-19.3 15.5-35.1 34.5-35.1s34.5 15.7 34.5 35.1v118.2c0 19.4-15.5 35.1-34.5 35.1zm-129 64c-19 0-34.5-15.7-34.5-35.1V199.4c0-19.3 15.5-35.1 34.5-35.1s34.5 15.7 34.5 35.1v218.8c0 19.3-15.5 35-34.5 35z"
      />
    </svg>
  )
}
